import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { FloatLabel } from 'primereact/floatlabel';
import { Dropdown } from 'primereact/dropdown';
import { PositionFilters } from '$constants/PositionFilters';
import InternalChipGroup from './InternalChipGroup/InternalChipGroup';
import InternalSearchBar from './InternalSearchBar/InternalSearchBar';
import classes from './PositionHeader.module.css';
import DropdownButton from '../../DropdownButton/DropdownButton';
import FilterContent from './FilterContent/FilterContent';
import FilterTypeSearchBar, {
  parseFilterTypeSearchBar,
} from './FilterContent/FilterTypeSearchBar';
import PositionInternalDto from '../../../types/serverTypes/positionInternalDto';

interface Props {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  allPositions: PositionInternalDto[];
}
const PositionHeader: FC<Props> = ({ setPage, allPositions }) => {
  const validPositionSortTypes = useMemo(
    () => [
      { name: 'Last Created', value: PositionFilters.Created },
      { name: 'Candidate Added', value: PositionFilters.CandidateAdded },
    ],
    []
  );

  const orderByPositionValues = useMemo(
    () => [
      { name: 'Descending', value: 'Desc' },
      { name: 'Ascending', value: 'Asc' },
    ],
    []
  );

  const [searchParmas, setSearchParams] = useSearchParams();
  const [querystringParams, setQuerystringParams] = useState({
    sortBy: (searchParmas.get('sortBy') ||
      validPositionSortTypes[0].value) as PositionFilters,
    orderBy: (searchParmas.get('orderBy') || orderByPositionValues[0].value) as
      | 'Asc'
      | 'Desc',
    option: (searchParmas.get('option') ||
      FilterTypeSearchBar.COMPANY) as FilterTypeSearchBar,
    query: '',
  });
  const [t] = useTranslation('global');

  const handleSetOption = (newOption: FilterTypeSearchBar) => {
    setQuerystringParams((prev) => ({
      ...prev,
      option: parseFilterTypeSearchBar(newOption),
    }));
  };

  useEffect(() => {
    const newParams = new URLSearchParams(searchParmas);
    Object.keys(querystringParams).forEach((paramName) => {
      newParams.set(
        paramName,
        querystringParams[paramName as keyof typeof querystringParams]
      );
    });

    setSearchParams(newParams);
    setPage(1);
  }, [querystringParams, searchParmas, setPage, setSearchParams]);

  return (
    <div className={classes.header}>
      <div className={classes.leftContent}>
        <h1 className={classes.Tittle}>{t('EmployerDashboard.Positions')} </h1>
        <InternalChipGroup setPage={setPage} />
      </div>
      <div className={classes.rightContent}>
        <InternalSearchBar
          allPositions={allPositions}
          barType={querystringParams.option}
          setQuerystring={setQuerystringParams}
        />
      </div>
      <div className="flex flex-row items-center gap-4 xl:mt-0 mt-4">
        <DropdownButton label="Filter by" isInternal isPosition>
          <FilterContent setOption={handleSetOption} />
        </DropdownButton>
        <FloatLabel className="mt-1">
          <label htmlFor="dd-sortyBy">Sort By </label>
          <Dropdown
            inputId="dd-sortyBy"
            value={querystringParams.sortBy}
            onChange={(e) =>
              setQuerystringParams((prev) => ({ ...prev, sortBy: e.value }))
            }
            options={validPositionSortTypes}
            optionLabel="name"
            className="w-full -mt-1"
          />
        </FloatLabel>
        <FloatLabel className="mt-1">
          <label htmlFor="dd-sortyBy">Order</label>
          <Dropdown
            inputId="dd-sortyBy"
            value={querystringParams.orderBy}
            onChange={(e) =>
              setQuerystringParams((prev) => ({ ...prev, orderBy: e.value }))
            }
            options={orderByPositionValues}
            optionLabel="name"
            className="w-full -mt-1"
          />
        </FloatLabel>
      </div>
    </div>
  );
};

export default PositionHeader;
